<template>
  <div class="fixed inset-0 p-8 grid grid-rows-auto-1 gap-4" style="background: rgba(0,0,0,0.88)">
    <div class="w-full text-right">
      <wd-button class="text-white hover:text-white" transparent @input="emitClose">
        <icon name="Close" />
      </wd-button>
    </div>
    <div class="overflow-y-auto">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  data() {
    return {};
  },
  props: {},
  components: {},
  methods: {
    emitClose() {
      this.$emit("close");
    }
  },
  computed: {},
  created() {}
};
</script>